import { useMemo } from "react";
import { useTable } from 'react-table';
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

export default function useModelInespections() {
    const { Models } = useSelector((state: RootState) => state.Model);

    const modelsData = useMemo(() => {
        if (!Models) return [];
        return [...Models].sort((a, b) => 
            a.modelNumber.localeCompare(b.modelNumber)
        );
    }, [Models]);

    const columns = useMemo(() => [
        {
            Header: 'Model Number',
            accessor: 'modelNumber',
        },
        {
            Header: 'Model Description',
            accessor: 'modelDescription',
        },
    ], []);


    return { ...useTable({ columns, data: modelsData }) };
}
